import 'date-fns';
import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

function DateButton(props) {
  const {
    selectedDate,
    handleDateChange,
    disableFuture,
    readOnly,
    label,
    onKeyPress,
    allowKeyboardControl,
  } = props;

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        disableToolbar
        disableFuture={disableFuture}
        variant="inline"
        format="MM/dd/yyyy"
        allowKeyboardControl={allowKeyboardControl}
        readOnly={readOnly}
        margin="normal"
        id="date-picker-inline"
        label={label}
        value={selectedDate}
        onChange={handleDateChange}
        onKeyPress={onKeyPress}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
      />
    </MuiPickersUtilsProvider>
  );
}

export default DateButton;
